import { SvgFactory } from '../../Svg';

const PlayPrevIcon = SvgFactory(
    <svg xmlns='http://www.w3.org/2000/svg' width='48' height='48' viewBox='0 0 48 48' fill='black'>
        <path d='M12.4912 36C12.0637 36 11.7083 35.8563 11.425 35.5688C11.1417 35.2812 11 34.925 11 34.5V13.5C11 13.075 11.1446 12.7188 11.4338 12.4313C11.723 12.1437 12.0813 12 12.5088 12C12.9363 12 13.2917 12.1437 13.575 12.4313C13.8583 12.7188 14 13.075 14 13.5V34.5C14 34.925 13.8554 35.2812 13.5663 35.5688C13.2771 35.8563 12.9187 36 12.4912 36ZM34.65 34.35L21.5 25.25C21.0333 24.9463 20.8 24.5287 20.8 23.9972C20.8 23.4657 21.0333 23.05 21.5 22.75L34.65 13.65C35.15 13.2833 35.6667 13.2427 36.2 13.5282C36.7333 13.8137 37 14.2543 37 14.85V33.15C37 33.7333 36.7333 34.1708 36.2 34.4625C35.6667 34.7542 35.15 34.7167 34.65 34.35Z' />
    </svg>,
);

export default PlayPrevIcon;
